import { render, staticRenderFns } from "./Valores.vue?vue&type=template&id=c59add12&scoped=true"
import script from "./Valores.vue?vue&type=script&setup=true&lang=js"
export * from "./Valores.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Valores.vue?vue&type=style&index=0&id=c59add12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59add12",
  null
  
)

export default component.exports